<template>
  <table id="content">
    <tr>
      <td>Versicherungsscheinnummer</td>
      <td>
        {{ insuranceExportBlank?.insuranceNumber }}

        <SogButton
          v-show="_insuranceNumberInfoVisibile"
          class="info-button"
          mdi-icon="mdi-shield"
          :button-style="SogButtonStyle.Link"
          @click="_onInsuranceInfoClicked"
        />
      </td>
    </tr>

    <tr>
      <td>Versicherer</td>
      <td>{{ insuranceExportBlank?.manufacturerName }}</td>
    </tr>
    <tr>
      <td>Kennzeichen</td>
      <td>
        {{ insuranceExportBlank?.kennzeichen }}
        <SogButton
          v-show="_kennzeichenInfoVisible"
          class="info-button"
          mdi-icon="mdi-car"
          :button-style="SogButtonStyle.Link"
          @click="_onKennzeichenInfoClicked"
        />
      </td>
    </tr>

    <tr>
      <td>Drucktyp</td>
      <td>{{ insuranceExportBlank?.printTypeDescription }}</td>
    </tr>

    <tr>
      <td>Gültigkeitsjahr</td>
      <td>{{ insuranceExportBlank?.printYearDescription }}</td>
    </tr>

    <tr>
      <td>Status</td>
      <td>{{ insuranceExportBlank?.statusDescription }}</td>
    </tr>
  </table>
</template>

<script setup lang="ts">

import InsuranceExportBlank from "@/shared/model/InsuranceExportBlank";
import {computed} from 'vue'
import {useNavigationStore} from "@/modules/Navigation/store";
import {IdType} from "@/shared/model/idType";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import SogButton from "@/shared/ui/SogButton.vue";

const _navigationStore = useNavigationStore()

interface Props {
  insuranceExportBlank?: InsuranceExportBlank,
}

const props = withDefaults(defineProps<Props>(), {
  insuranceExportBlank: undefined,
})

const _insuranceNumberInfoVisibile = computed(() => {
  return props.insuranceExportBlank?.insuranceId != null
})

const _kennzeichenInfoVisible = computed(() => {
  return props.insuranceExportBlank?.kennzeichen != null
})

function _onInsuranceInfoClicked() {
  _navigationStore.currentInsuranceId = props.insuranceExportBlank?.insuranceId
  _navigationStore.currentInsuranceNumber = props.insuranceExportBlank?.insuranceNumber
}

function _onKennzeichenInfoClicked() {
  _navigationStore.currentVehicleRegistrationId = props.insuranceExportBlank?.vehicleRegistrationId
}

</script>

<style scoped>

#content tr td:last-child {
  padding-left: 20px;
}

.info-button {
  padding: 1px;
}

</style>
